import { render, staticRenderFns } from "./HistoricPersonalDoctors.vue?vue&type=template&id=30baf583"
import script from "./HistoricPersonalDoctors.vue?vue&type=script&lang=js"
export * from "./HistoricPersonalDoctors.vue?vue&type=script&lang=js"
import style0 from "./HistoricPersonalDoctors.vue?vue&type=style&index=0&id=30baf583&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports